var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card shadow mb-4" }, [
    _c("div", { staticClass: "card-header py-3" }, [
      _c(
        "a",
        {
          staticClass: "float-right",
          attrs: { href: "#" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.back()
            }
          }
        },
        [
          _c("i", { staticClass: "fas fa-fw fa-arrow-circle-left" }),
          _vm._v(" Back")
        ]
      ),
      _vm._v(" "),
      _vm.partner
        ? _c("h6", { staticClass: "m-0 font-weight-bold text-primary" }, [
            _vm._v(_vm._s(_vm.partner.name) + " "),
            _c("i", { staticClass: "fas fa-fw fa-angle-double-right" }),
            _vm._v(" " + _vm._s(_vm.title))
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "form-row" }, [
        _c("div", { staticClass: "form-group col-md-12" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tab-content", attrs: { id: "nav-tabContent" } },
            [
              _c(
                "div",
                {
                  staticClass:
                    "tab-pane fade show active p-3 border-left border-bottom border-right",
                  attrs: {
                    id: "agents",
                    role: "tabpanel",
                    "aria-labelledby": "nav-agents-tab"
                  }
                },
                [
                  _vm.partner
                    ? _c("agents", { attrs: { partner: _vm.partner } })
                    : _vm._e()
                ],
                1
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-row" }, [
        _c(
          "div",
          { staticClass: "form-group col-md-6" },
          [_c("error-reveal", { attrs: { error: _vm.error } })],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("nav", [
      _c(
        "div",
        {
          staticClass: "nav nav-tabs",
          attrs: { id: "nav-tab", role: "tablist" }
        },
        [
          _c(
            "a",
            {
              staticClass: "nav-item nav-link active",
              attrs: {
                id: "nav-agents-tab",
                "data-toggle": "tab",
                href: "#agents",
                role: "tab",
                "aria-controls": "agents",
                "aria-selected": "true"
              }
            },
            [_vm._v("System users")]
          )
        ]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }